<bit-section [disableMargin]="disableMargin" class="bv-generator-passphrase-settings">
  <form [formGroup]="settings" class="tw-container">
    <div class="bv-generator-passphrase-settings__fields">
      <bit-form-field disableMargin>
        <bit-label>{{ "numWords" | i18n }}</bit-label>
        <input
          bitInput
          formControlName="numWords"
          id="num-words"
          type="number"
          (change)="save('numWords')"
        />
        <bit-hint>{{ numWordsBoundariesHint$ | async }}</bit-hint>
      </bit-form-field>
      <bit-form-field disableMargin>
        <bit-label>{{ "wordSeparator" | i18n }}</bit-label>
        <input
          bitInput
          formControlName="wordSeparator"
          id="word-separator"
          type="text"
          [maxlength]="wordSeparatorMaxLength"
          (change)="save('wordSeparator')"
        />
      </bit-form-field>
    </div>

    <section class="bv-generator__section bv-generator__section--options">
      <h3 class="bv-generator__heading">{{ "options" | i18n }}</h3>
      <div class="bv-generator-passphrase-settings__options">
        <bit-form-control>
          <input
            bitCheckbox
            formControlName="capitalize"
            id="capitalize"
            type="checkbox"
            (change)="save('capitalize')"
          />
          <bit-label>{{ "capitalize" | i18n }}</bit-label>
        </bit-form-control>
        <bit-form-control [disableMargin]="!policyInEffect">
          <input
            bitCheckbox
            formControlName="includeNumber"
            id="include-number"
            type="checkbox"
            (change)="save('includeNumber')"
          />
          <bit-label>{{ "includeNumber" | i18n }}</bit-label>
        </bit-form-control>
      </div>
      @if (policyInEffect) {
        <p bitTypography="helper">{{ "generatorPolicyInEffect" | i18n }}</p>
      }
    </section>
  </form>
</bit-section>
